import styled from 'styled-components'
import { components, DropdownIndicatorProps } from 'react-select'

import { colors } from '@/styles'
import { SearchIcon } from '@/components/icons'

const SearchWrapper = styled.div<{ customColor?: string }>`
  background-color: ${props => props.customColor || colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const DropdownIndicator = (
  props: DropdownIndicatorProps & {
    customColor?: string
    showFilters?: boolean
    boundaries?: {
      top_left: { lat: number; lng: number }
      bottom_right: { lat: number; lng: number }
    }
    centerPoint?: number[]
  }
) => {
  const { customColor, ...rest } = props

  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator
        {...rest}
        innerProps={{
          ...rest.innerProps
        }}
      >
        <SearchWrapper customColor={customColor}>
          <SearchIcon />
        </SearchWrapper>
      </components.DropdownIndicator>
    )
  )
}

export default DropdownIndicator
